var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7159_2360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#0059A9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0327 38.5996L23.1987 53.3335H19.3047L25.9087 35.5601H28.3867L28.0327 38.5996ZM32.0488 53.3335L27.2026 38.5996L26.812 35.5601H29.3145L35.9551 53.3335H32.0488ZM31.8291 46.7173V49.5859H22.4419V46.7173H31.8291ZM49.9561 42.7988V45.6553H40.6787V42.7988H49.9561ZM41.7651 35.5601V53.3335H38.103V35.5601H41.7651ZM52.5684 35.5601V53.3335H48.9185V35.5601H52.5684ZM63.1758 46.998H58.647V44.1416H63.1758C63.8757 44.1416 64.4453 44.0277 64.8848 43.7998C65.3242 43.5638 65.6457 43.2383 65.8491 42.8232C66.0526 42.4082 66.1543 41.9403 66.1543 41.4194C66.1543 40.8905 66.0526 40.3981 65.8491 39.9424C65.6457 39.4867 65.3242 39.1204 64.8848 38.8438C64.4453 38.5671 63.8757 38.4287 63.1758 38.4287H59.9165V53.3335H56.2544V35.5601H63.1758C64.5674 35.5601 65.7596 35.8123 66.7524 36.3169C67.7534 36.8133 68.5184 37.501 69.0474 38.3799C69.5763 39.2588 69.8408 40.2638 69.8408 41.395C69.8408 42.5425 69.5763 43.5353 69.0474 44.3735C68.5184 45.2118 67.7534 45.8587 66.7524 46.3145C65.7596 46.7702 64.5674 46.998 63.1758 46.998Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7159_2360",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7159_2360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7159_2360",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAhp);
export default __webpack_public_path__ + "static/media/LogoAHP.824703f282b763f41d6afdd6e26aba12.svg";
export { ForwardRef as ReactComponent };